/*****
 * Created by Allan on 2021/11/05.
 * Contact 84880528@qq.com.
 * *****/
import Vue from 'vue'
import Vuex from 'vuex'
import global from '@/baseloan/store/module/global'  //共用
import user from '@/baseloan/store/module/user'  //用户登入信息

Vue.use(Vuex);
export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production', //在非生产环境下，使用严格模式
    modules:{
        global,
        user,
    }
})



// WEBPACK FOOTER //
// ./src/baseloan/store/index.js